import React, { useEffect, useLayoutEffect, useContext, useMemo } from 'react'
import Icon from './Icon'
import Nl2br from './Nl2br'
import AmazonProductSmall from './AmazonProductSmall'
import { ResourcesContext } from './ArticleResourcesContent'
import Button from './Button'
import Loading from './Loading'
import Input from './Input'
import useData from '../hooks/useData'
import useModal from '../hooks/useModal'
import { appStateContext } from '../App'
import { ButtonGroup, UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import { createFilter } from 'react-select'
import Clipboard from 'react-clipboard.js'
import Confirmation from './Confirmation'
import Flag from './Flag'
const uuidv4 = require('uuid/v4')

const resource_item_class = { amazon: 'amazon', google: 'google', competitor: 'competitor' }
const layout = () => {
    const bucket = document.querySelector('#resource-bucket')
    bucket && (bucket.style.height = window.innerHeight - document.querySelector('#resource-bucket').getBoundingClientRect().top + 'px')
}
const ArticleResourcesColumn = React.memo(function ArticleResourcesColumn(props) {
    const appState = useContext(appStateContext)
    const resourcesContext = useContext(ResourcesContext)
    const { addSelectedText, resourceApi, updateResources, site, resources } = resourcesContext || props
    const { article_id } = props

    const articleData = useData(
        {
            url: 'article/' + appState.state.resource_article_id,
            transform: (data) => ({
                ...data,
                resources: (data.resources && JSON.parse(data.resources)) || null,
            }),
        },
        [!!appState.state.resource_article_id]
    )

    const deleteResource = (id) => {
        updateResources && updateResources(resources.filter((r) => r.id !== id))
    }

    const updateProduct = (id, payload) => {
        const resource = resources.find((r) => r.id === id)
        console.log('updateProduct called')
        updateResources &&
            updateResources(
                resources.reduce((acc, r) => {
                    acc.push((r.id === id && { ...resource, ...payload }) || r)
                    return acc
                }, [])
            )
    }
    // console.log({props})
    const confirmModal = useModal(false)
    const emptyResources = () => {
        updateResources([])
    }

    useLayoutEffect(() => {
        layout()
        window.addEventListener('resize', layout)
        return () => window.removeEventListener('resize', layout)
    })

    const siteArray = useData('site', [])
    const articleArray = useData('article?scope=dd_list', [])
    // console.log({ articleArray })

    const article_dd_list = useMemo(
        () =>
            (articleArray.isReady &&
                siteArray.isReady &&
                siteArray.data
                    .sort((a, b) => a.label.localeCompare(b.label))
                    .reduce((acc, s) => {
                        acc = [
                            ...acc,
                            ...articleArray.data
                                .filter((a) => a.site_id === s.id)
                                .map((a) => ({
                                    label: s.label + ' - ' + a.title,
                                    jsx_label: (
                                        <>
                                            <Flag locale={s.locale} /> {s.label + ' - ' + a.title}
                                        </>
                                    ),
                                    value: a.id,
                                })),
                        ]
                        return acc
                    }, [])) ||
            [],
        [articleArray.data, siteArray.data]
    )

    const onArticleChange = ({ value: resource_article_id }) => {
        resource_article_id && resource_article_id !== 'undefined' && appState.setState({ resource_article_id })
        resource_article_id && resource_article_id !== 'undefined' && localStorage.setItem('resource_article_id', resource_article_id)
    }

    useEffect(() => {
        // console.log(article_id)
        if (article_id && appState.state.resource_article_id !== article_id) {
            onArticleChange(article_id)
        }
    }, [article_id])

    const onDragStartNewBlock = (e, param, text) => {
        e.dataTransfer.setData('text/plain', '')
        window.drag_target = null
        window.drag_target_id = param
        window.drag_text = text
    }
    const drag_drop_props = (text) => ({
        draggable: true,
        onDragStart: (e) => onDragStartNewBlock(e, 'text', text),
        onDrop: () => {
            console.log('element dropped')
        },
        onDragOver: (event) => event.preventDefault(),
        onDragEnd: () => {
            console.log('onDragEnd')
        },
    })
    // const getASIN = obj => (obj.providerProductId && (obj.providerProductId.ASIN || obj.providerProductId.creativeASIN)) || obj.ASIN || obj.external_id
    const grabAllResourcesFromInspectedPage = () => {
        // const text_array = [...document.querySelectorAll('.resource-target-text')]
        const page_resource_node_array = [...document.querySelectorAll('.resource-target-text, [data-provider-product')]
        console.log({ page_resource_node_array })
        const page_resource_array = page_resource_node_array.reduce((acc, n) => {
            if (n.dataset.providerProduct) {
                const providerProductId = JSON.parse(n.dataset.providerProductId)
                if (
                    !acc.find(
                        (_n) =>
                            _n.providerProductId &&
                            ((_n.providerProductId.ASIN && _n.providerProductId.ASIN == providerProductId.ASIN) ||
                                (_n.providerProductId.creativeASIN && _n.providerProductId.creativeASIN == providerProductId.creativeASIN))
                    )
                ) {
                    acc.push({
                        type: 'product',
                        provider: 'amazon',
                        id: uuidv4(),
                        displayUrl: props.displayUrl,
                        originalUrl: props.originalUrl,
                        origin: '',
                        providerProductId,
                    })
                }
            } else {
                acc.push({ type: 'text', id: uuidv4(), displayUrl: props.displayUrl, originalUrl: props.originalUrl, text: n.innerText })
            }
            return acc
        }, [])
        updateResources([...resources, ...page_resource_array])
    }

    return (
        <>
            {(props.isLoading && <Loading text="Loading articles and resources" />) || (
                <div className={'resource-bucket-controlled-width' + ((props.className && ' ' + props.className) || '')} style={{ position: 'fixed' }}>
                    <div className="resource-bucket-controlled-width" style={{ position: 'fixed', zIndex: '1' }}>
                        {(props.Header && <props.Header />) || null}
                        <Input
                            className="w-100"
                            type="select"
                            options={article_dd_list}
                            onChange={onArticleChange}
                            value={appState.state.resource_article_id}
                            filterOption={createFilter({
                                ignoreCase: true,
                                ignoreAccents: true,
                                matchFrom: 'any',
                                stringify: (option) => `${option.data.label} ${option.value}`,
                                trim: true,
                            })}
                            getOptionLabel={(option) => option.jsx_label}
                        />
                        {(articleData.isLoading && <></>) || (
                            <>
                                {(props.grabText && appState.state.resource_article_id && addSelectedText && (
                                    <div className="pb-3 sticky-toolbar bg-white resource-bucket-controlled-width">
                                        {(props.grabPage && (
                                            <ButtonGroup className="w-100 mt-3" size="sm">
                                                <Button
                                                    className="btn-secondary w-100"
                                                    onClick={() =>
                                                        addSelectedText({
                                                            displayUrl_: props.displayUrl,
                                                            originalUrl_: props.originalUrl,
                                                            origin_: props.origin,
                                                        })
                                                    }
                                                    {...resourceApi}
                                                >
                                                    {(resourceApi.isLoading && 'SAVING') || 'GRAB TEXT'}
                                                </Button>
                                                <UncontrolledButtonDropdown>
                                                    <DropdownToggle caret className="btn btn-secondary" disabled={resourceApi.isLoading} />
                                                    <DropdownMenu right>
                                                        <DropdownItem onClick={grabAllResourcesFromInspectedPage}>
                                                            {(resourceApi.isLoading && 'SAVING') || 'GRAB PAGE'}
                                                        </DropdownItem>
                                                        <DropdownItem onClick={confirmModal.toggle}>Empty bucket</DropdownItem>
                                                    </DropdownMenu>
                                                </UncontrolledButtonDropdown>
                                            </ButtonGroup>
                                        )) || (
                                            // <Button className='btn-secondary w-100 mt-3' onClick={() => addSelectedText({ displayUrl_: props.displayUrl, originalUrl_: props.originalUrl, origin_: props.origin })} {...resourceApi}>
                                            //     {(resourceApi.isLoading && 'SAVING') || 'GRAB TEXT'}
                                            // </Button>
                                            <ButtonGroup className="w-100 mt-3" size="sm">
                                                <Button
                                                    className="btn-secondary w-100"
                                                    onClick={() =>
                                                        addSelectedText({
                                                            displayUrl_: props.displayUrl,
                                                            originalUrl_: props.originalUrl,
                                                            origin_: props.origin,
                                                        })
                                                    }
                                                    {...resourceApi}
                                                >
                                                    {(resourceApi.isLoading && 'SAVING') || 'GRAB TEXT'}
                                                </Button>
                                                <UncontrolledButtonDropdown>
                                                    <DropdownToggle caret className="btn btn-secondary" disabled={resourceApi.isLoading} />
                                                    <DropdownMenu right>
                                                        <DropdownItem onClick={confirmModal.toggle}>Empty bucket</DropdownItem>
                                                    </DropdownMenu>
                                                </UncontrolledButtonDropdown>
                                            </ButtonGroup>
                                        )}
                                    </div>
                                )) ||
                                    null}
                            </>
                        )}
                    </div>
                    <div
                        id="resource-bucket-container"
                        className={
                            ((props.high || props.Header || props.grabText) && 'resource-bucket-container-high resource-bucket-controlled-width') ||
                            'resource-bucket-controlled-width'
                        }
                    >
                        {(articleData.isLoading && (
                            <>
                                <Loading text="Loading articles and resources" />
                            </>
                        )) || (
                            <div className="resource-bucket-controlled-width">
                                <div id="resource-bucket">
                                    {(resources && Array.isArray(resources) && (
                                        <ul className="list-unstyled">
                                            {resources.map((r, index) => (
                                                <li className="mt-3" key={`text-${r.id}-${index}`}>
                                                    {(r.type === 'text' && (
                                                        <>
                                                            <div className="mt-3">
                                                                <span className={'badge badge-' + (resource_item_class[r.origin] || 'secondary') + ' mb-2'}>
                                                                    {r.displayUrl}
                                                                    <Icon name="close" className="ml-2 pointer" onClick={() => deleteResource(r.id)} />
                                                                </span>
                                                                <br />

                                                                {(props.dd && (
                                                                    <>
                                                                        <span {...drag_drop_props(r.text)} className="badge badge-secondary pointer mr-1">
                                                                            <Icon name="text" />
                                                                        </span>
                                                                        <Clipboard className="badge badge-secondary pointer mr-1" data-clipboard-text={r.text}>
                                                                            <i className="fal fa-copy" />
                                                                        </Clipboard>
                                                                    </>
                                                                )) ||
                                                                    null}
                                                                <small>
                                                                    <Nl2br>{r.text}</Nl2br>
                                                                </small>
                                                            </div>
                                                            <hr />
                                                        </>
                                                    )) ||
                                                        null}
                                                    {(r.type === 'product' && (
                                                        <>
                                                            <div className="mt-3">
                                                                {/* {console.log(r)} */}
                                                                <span className={'badge badge-' + (resource_item_class[r.origin] || 'secondary') + ' mb-2'}>
                                                                    {r.displayUrl}
                                                                    <Icon name="close" className="ml-2 pointer" onClick={() => deleteResource(r.id)} />
                                                                </span>
                                                                <br />
                                                                <AmazonProductSmall
                                                                    {...r}
                                                                    tracking_id={r.tracking_id || (site && site.tracking_id)}
                                                                    locale={r.locale || (site && site.locale)}
                                                                    updateProduct={updateProduct}
                                                                    site={site}
                                                                />
                                                            </div>
                                                            <hr />
                                                        </>
                                                    )) ||
                                                        null}
                                                </li>
                                            ))}
                                        </ul>
                                    )) ||
                                        null}
                                </div>
                            </div>
                        )}
                    </div>
                    <Confirmation
                        {...confirmModal}
                        confirm={emptyResources}
                        title={'Empty resources bucket'}
                        text={'Are you sure you want to empty the resources bucket?'}
                    />
                </div>
            )}
        </>
    )
})

export default ArticleResourcesColumn
